<template>
  <el-table :data="tableData" stripe style="width: 100%;" height="300px">
    <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip
    >
      <template v-if="col.prop === 'DTBorrowDate'" #default="scope">
        {{ formatDate(scope.row.DTCreatedDate) }}
      </template>
      <template v-if="col.prop === 'DTReturnDate'" #default="scope">
        {{ formatDate(scope.row.DTReturnDate) }}
      </template>
      <template v-if="col.prop === 'IsReturn'" #default="scope">
        {{ scope.row.IsReturn ? '已归还' : '未归还' }}
      </template>
    </el-table-column>
    <!-- 具名插槽：操作列 -->
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: Array
  },
  data() {
    return {
      columns: [
        { prop: "StrReaderCardNumber", label: "卡号"},
        { prop: "StrReaderName", label: "姓名" },
        { prop: "DepartmentName", label: "部门"},
        { prop: "GroupName", label: "小组"},
        { prop: "StrPositiveTitle", label: "所借图书"},
        { prop: "StrBookBarcode", label: "图书条码"},
        { prop: "DTBorrowDate", label: "借阅时间"},
        { prop: "DTReturnDate", label: "应还时间"},
        { prop: "IsReturn", label: "是否归还"},
        { prop: "StrCreatorName", label: "操作员"},
      ]
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>
